export const SET_VIEWERS = 'VIEWERS::SET'



// WEBPACK FOOTER //
// ./src/types/actions/viewers.js